<template>
	<t-menu-item v-for="item in menuItems" :key="item.path" :value="item.path" @click="handleClick(item)">
		{{ item.title }}
	</t-menu-item>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

interface MenuItem {
	path: string
	name: string
	title: string
}

const props = defineProps<{
	menuItems: MenuItem[]
}>()

const menuItems = computed(() => {
	return props.menuItems
})

const handleClick = (item: MenuItem) => {
	router.push({
		path: item.path,
	})
}
</script>

<style scoped>
/* 移除重复的样式，让Header组件统一管理菜单样式 */
</style>
